import { c as _c } from "react/compiler-runtime";
import { type CSSProperties, type ForwardedRef, forwardRef, memo } from 'react';

// ----------------------------------------------------------------------------- STYLE

const _styles = {
  opacities: {
    full: 1,
    hidden: 0.2
  },
  labels: {
    dashWidth: 0.5
  },
  transitions: {
    transition: 'opacity 170ms ease'
  }
};

// ----------------------------------------------------------------------------- GRAPHICS ROOT

interface AnimationVaultsWorksSVGProps {
  style?: CSSProperties;
  className?: string;
  base: string;
  selectedPart?: number;
  backgroundFillColor?: string;
  textFillColor?: string;
  pathsFillColor?: string;
}
function HowItWorksEarnGraphics(t0, ref) {
  const $ = _c(187);
  const {
    style,
    className,
    base,
    selectedPart,
    backgroundFillColor,
    textFillColor,
    pathsFillColor
  } = t0;
  const t1 = selectedPart === 0 ? _styles.opacities.full : _styles.opacities.hidden;
  let t2;
  if ($[0] !== textFillColor) {
    t2 = <path d="M53.6741 59.9883H55.1461V70.2203H61.5461V71.5083H53.6741V59.9883ZM62.5421 67.4283C62.5421 64.6603 64.0781 63.1643 66.4941 63.1643C68.9181 63.1643 70.2541 64.6763 70.2541 67.0763V67.7803H63.9021C63.9341 69.4763 64.9101 70.5643 66.4941 70.5643C67.9981 70.5643 68.6941 69.7083 68.8221 68.9563H70.0861V69.1963C69.9021 70.1963 68.9581 71.7003 66.5101 71.7003C64.0941 71.7003 62.5421 70.2043 62.5421 67.4283ZM63.9261 66.6683H68.9101C68.8941 65.2763 68.0701 64.2923 66.4861 64.2923C64.9341 64.2923 64.0381 65.2923 63.9261 66.6683ZM72.0926 63.3563H73.4606V64.4043H73.5886C74.1726 63.5163 75.1566 63.1723 76.3166 63.1723C78.2126 63.1723 79.3966 64.1323 79.3966 66.1243V71.5083H77.9886V66.2603C77.9886 64.9323 77.2686 64.3483 75.9966 64.3483C74.6046 64.3483 73.5006 65.1723 73.5006 66.9563V71.5083H72.0926V63.3563ZM89.1435 59.9883V71.5083H87.7755V70.3883H87.6475C87.0315 71.3243 86.0475 71.6923 84.8875 71.6923C82.7675 71.6923 81.1515 70.2523 81.1515 67.4363C81.1515 64.6123 82.7675 63.1723 84.8875 63.1723C86.0235 63.1723 86.9995 63.5323 87.6075 64.4363H87.7355V59.9883H89.1435ZM82.5675 67.4363C82.5675 69.4123 83.6235 70.5243 85.1755 70.5243C86.7355 70.5243 87.7915 69.4123 87.7915 67.4363C87.7915 65.4523 86.7355 64.3403 85.1755 64.3403C83.6235 64.3403 82.5675 65.4523 82.5675 67.4363ZM90.9796 67.4283C90.9796 64.6603 92.5156 63.1643 94.9316 63.1643C97.3556 63.1643 98.6916 64.6763 98.6916 67.0763V67.7803H92.3396C92.3716 69.4763 93.3476 70.5643 94.9316 70.5643C96.4356 70.5643 97.1316 69.7083 97.2596 68.9563H98.5236V69.1963C98.3396 70.1963 97.3956 71.7003 94.9476 71.7003C92.5316 71.7003 90.9796 70.2043 90.9796 67.4283ZM92.3636 66.6683H97.3476C97.3316 65.2763 96.5076 64.2923 94.9236 64.2923C93.3716 64.2923 92.4756 65.2923 92.3636 66.6683ZM100.53 63.3563H101.89V64.3323H102.018C102.298 63.7563 102.81 63.3243 104.034 63.3243H105.17V64.5403H104.066C102.538 64.5403 101.938 65.3803 101.938 67.0363V71.5083H100.53V63.3563Z" fill={textFillColor} />;
    $[0] = textFillColor;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== pathsFillColor) {
    t3 = <path d="M276 66L117 66" stroke={pathsFillColor} strokeWidth={_styles.labels.dashWidth} strokeLinecap="round" />;
    $[2] = pathsFillColor;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <g opacity={t1} style={_styles.transitions}>{t2}{t3}</g>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = selectedPart === 0 ? _styles.opacities.full : _styles.opacities.hidden;
  let t6;
  if ($[8] !== textFillColor) {
    t6 = <path d="M4.95097 5.6859C7.70697 5.6859 9.53997 7.4539 9.53997 10.3659C9.53997 13.2779 7.70697 15.0459 4.95097 15.0459H1.51897V5.6859H4.95097ZM2.70847 14.0189H4.91847C6.95947 14.0189 8.33097 12.7254 8.33097 10.3659C8.33097 8.0064 6.95947 6.7129 4.91847 6.7129H2.70847V14.0189ZM10.6539 11.7309C10.6539 9.4819 11.9019 8.2664 13.8649 8.2664C15.8344 8.2664 16.9199 9.4949 16.9199 11.4449V12.0169H11.7589C11.7849 13.3949 12.5779 14.2789 13.8649 14.2789C15.0869 14.2789 15.6524 13.5834 15.7564 12.9724H16.7834V13.1674C16.6339 13.9799 15.8669 15.2019 13.8779 15.2019C11.9149 15.2019 10.6539 13.9864 10.6539 11.7309ZM11.7784 11.1134H15.8279C15.8149 9.9824 15.1454 9.1829 13.8584 9.1829C12.5974 9.1829 11.8694 9.9954 11.7784 11.1134ZM18.4137 17.6459V8.4224H19.5317V9.3389H19.6357C20.1297 8.5719 20.9357 8.2729 21.8717 8.2729C23.5942 8.2729 24.9137 9.4429 24.9137 11.7374C24.9137 14.0254 23.5942 15.1954 21.8717 15.1954C20.9552 15.1954 20.1557 14.9029 19.6617 14.1684H19.5577V17.6459H18.4137ZM19.5187 11.7374C19.5187 13.3429 20.3767 14.2464 21.6377 14.2464C22.9052 14.2464 23.7632 13.3429 23.7632 11.7374C23.7632 10.1254 22.9052 9.2219 21.6377 9.2219C20.3767 9.2219 19.5187 10.1254 19.5187 11.7374ZM26.0025 11.7374C26.0025 9.5014 27.361 8.2664 29.376 8.2664C31.3845 8.2664 32.7495 9.5014 32.7495 11.7374C32.7495 13.9669 31.3845 15.2019 29.376 15.2019C27.361 15.2019 26.0025 13.9669 26.0025 11.7374ZM27.1595 11.7374C27.1595 13.3754 28.05 14.2659 29.376 14.2659C30.6955 14.2659 31.586 13.3754 31.586 11.7374C31.586 10.0929 30.6955 9.2089 29.376 9.2089C28.05 9.2089 27.1595 10.0929 27.1595 11.7374ZM33.9201 10.1579C33.9201 8.9814 34.9211 8.2729 36.6176 8.2729C38.3206 8.2729 39.3606 8.9814 39.4646 10.2424V10.4374H38.4181C38.3726 9.5209 37.6576 9.1764 36.6241 9.1764C35.5906 9.1764 35.0121 9.5144 35.0121 10.1319C35.0121 10.7494 35.5061 10.9899 36.2081 11.0744L37.3456 11.2174C38.6651 11.3799 39.5751 11.9454 39.5751 13.1544C39.5751 14.3764 38.6261 15.1954 36.8061 15.1954C34.9861 15.1954 33.8486 14.3829 33.7706 13.1804V12.9854H34.8301C34.8951 13.8824 35.7011 14.2919 36.8061 14.2919C37.9176 14.2919 38.4701 13.8759 38.4701 13.2129C38.4701 12.5629 37.9501 12.2769 37.0986 12.1664L35.9611 12.0234C34.7326 11.8674 33.9201 11.3214 33.9201 10.1579ZM40.9733 8.4224H42.1173V15.0459H40.9733V8.4224ZM40.8888 7.2914V6.0369H42.2148V7.2914H40.8888ZM43.2924 8.4224H44.8589V6.6024H46.0029V8.4224H47.9854V9.3519H46.0029V13.9539L46.1069 14.0579H47.9659V15.0459H46.5619C45.4764 15.0459 44.8589 14.5064 44.8589 13.4274V9.3519H43.2924V8.4224ZM52.1066 5.6859H53.2766L55.1616 13.7394H55.2656L57.4301 5.6859H58.8471L61.0051 13.7394H61.1091L62.9941 5.6859H64.1316V5.8809L61.9021 15.0459H60.2901L58.1711 7.1744H58.0671L55.9481 15.0459H54.3361L52.1066 5.8809V5.6859ZM65.5795 5.6859H72.0925V6.6934H66.7625V9.8134H71.4425V10.8209H66.7625V14.0384H72.1835V15.0459H65.5795V5.6859ZM73.0211 5.6859H80.9771V6.7194H77.5971V15.0459H76.4011V6.7194H73.0211V5.6859ZM82.3754 5.6859H83.5649V9.8199H88.5829V5.6859H89.7789V15.0459H88.5829V10.8729H83.5649V15.0459H82.3754V5.6859Z" fill={textFillColor} transform="scale(1.18) translate(-14 -2)" />;
    $[8] = textFillColor;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== pathsFillColor) {
    t7 = <path d="M220 10L101 10" stroke={pathsFillColor} strokeWidth={_styles.labels.dashWidth} strokeLinecap="round" />;
    $[10] = pathsFillColor;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <g opacity={t5} style={_styles.transitions} transform="translate(68, 225)">{t6}{t7}</g>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = selectedPart === 0 || selectedPart === 1 ? _styles.opacities.full : _styles.opacities.hidden;
  let t10;
  if ($[16] !== textFillColor) {
    t10 = <path d="M52.9207 445.365H54.3607L56.6807 455.277H56.8087L59.4727 445.365H61.2167L63.8727 455.277H64.0007L66.3207 445.365H67.7207V445.605L64.9767 456.885H62.9927L60.3847 447.197H60.2567L57.6487 456.885H55.6647L52.9207 445.605V445.365ZM69.5027 445.365H77.5187V446.605H70.9587V450.445H76.7187V451.685H70.9587V455.645H77.6307V456.885H69.5027V445.365ZM78.6616 445.365H88.4536V446.637H84.2936V456.885H82.8216V446.637H78.6616V445.365ZM90.1746 445.365H91.6386V450.453H97.8146V445.365H99.2866V456.885H97.8146V451.749H91.6386V456.885H90.1746V445.365ZM105.075 445.365H106.555L110.179 455.389H110.307L113.939 445.365H115.371V445.605L111.171 456.885H109.283L105.075 445.605V445.365ZM115.685 450.997C115.853 449.485 117.149 448.541 119.261 448.541C121.357 448.541 122.589 449.485 122.589 451.517V456.885H121.277V455.765H121.149C120.805 456.397 119.957 457.061 118.285 457.061C116.525 457.061 115.293 456.173 115.293 454.653C115.293 453.037 116.517 452.325 118.165 452.117L121.229 451.733V451.437C121.229 450.165 120.549 449.661 119.229 449.661C117.901 449.661 117.117 450.165 117.005 451.237H115.685V450.997ZM116.693 454.589C116.693 455.437 117.405 455.925 118.517 455.925C120.005 455.925 121.229 455.125 121.229 453.325V452.821L118.445 453.189C117.365 453.333 116.693 453.733 116.693 454.589ZM132.012 456.885H130.644V455.845H130.516C129.94 456.725 128.964 457.069 127.804 457.069C125.908 457.069 124.74 456.109 124.74 454.117V448.733H126.148V453.981C126.148 455.309 126.852 455.893 128.124 455.893C129.516 455.893 130.604 455.069 130.604 453.285V448.733H132.012V456.885ZM134.327 445.365H135.735V456.885H134.327V445.365ZM137.182 448.733H139.11V446.493H140.518V448.733H142.958V449.877H140.518V455.541L140.646 455.669H142.934V456.885H141.206C139.87 456.885 139.11 456.221 139.11 454.893V449.877H137.182V448.733Z" fill={textFillColor} />;
    $[16] = textFillColor;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== pathsFillColor) {
    t11 = <path d="M204.972 451.887L155.972 451.883" stroke={pathsFillColor} strokeWidth={_styles.labels.dashWidth} strokeLinecap="round" />;
    $[18] = pathsFillColor;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t9) {
    t12 = <g opacity={t9} style={_styles.transitions}>{t10}{t11}</g>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = selectedPart === 2 ? _styles.opacities.full : _styles.opacities.hidden;
  let t14;
  if ($[24] !== textFillColor) {
    t14 = <path d="M58.4732 1378.91C60.5212 1378.91 62.0412 1379.87 62.0412 1381.81C62.0412 1383.65 60.8412 1384.26 60.1612 1384.41V1384.54C60.8972 1384.71 62.2572 1385.29 62.2572 1387.29C62.2572 1389.41 60.6332 1390.43 58.5292 1390.43H53.4012V1378.91H58.4732ZM54.8492 1389.19H58.3692C59.7852 1389.19 60.8172 1388.63 60.8172 1387.19C60.8172 1385.74 59.7852 1385.19 58.3692 1385.19H54.8492V1389.19ZM54.8492 1383.95H58.2892C59.6092 1383.95 60.6332 1383.45 60.6332 1382.05C60.6332 1380.65 59.6092 1380.15 58.2892 1380.15H54.8492V1383.95ZM63.6129 1386.35C63.6129 1383.6 65.2849 1382.08 67.7649 1382.08C70.2369 1382.08 71.9169 1383.6 71.9169 1386.35C71.9169 1389.1 70.2369 1390.62 67.7649 1390.62C65.2849 1390.62 63.6129 1389.1 63.6129 1386.35ZM65.0369 1386.35C65.0369 1388.37 66.1329 1389.47 67.7649 1389.47C69.3889 1389.47 70.4849 1388.37 70.4849 1386.35C70.4849 1384.33 69.3889 1383.24 67.7649 1383.24C66.1329 1383.24 65.0369 1384.33 65.0369 1386.35ZM73.7415 1382.27H75.1015V1383.25H75.2295C75.5095 1382.67 76.0215 1382.24 77.2455 1382.24H78.3815V1383.46H77.2775C75.7495 1383.46 75.1495 1384.3 75.1495 1385.95V1390.43H73.7415V1382.27ZM79.9447 1382.27H81.3047V1383.25H81.4327C81.7127 1382.67 82.2247 1382.24 83.4487 1382.24H84.5847V1383.46H83.4807C81.9527 1383.46 81.3527 1384.3 81.3527 1385.95V1390.43H79.9447V1382.27ZM85.3473 1386.35C85.3473 1383.6 87.0193 1382.08 89.4993 1382.08C91.9713 1382.08 93.6513 1383.6 93.6513 1386.35C93.6513 1389.1 91.9713 1390.62 89.4993 1390.62C87.0193 1390.62 85.3473 1389.1 85.3473 1386.35ZM86.7713 1386.35C86.7713 1388.37 87.8673 1389.47 89.4993 1389.47C91.1233 1389.47 92.2193 1388.37 92.2193 1386.35C92.2193 1384.33 91.1233 1383.24 89.4993 1383.24C87.8673 1383.24 86.7713 1384.33 86.7713 1386.35ZM94.5654 1382.27H95.9094L97.5654 1388.82H97.7014L99.6854 1382.27H101.245L103.237 1388.82H103.365L105.013 1382.27H106.317V1382.51L104.181 1390.43H102.493L100.509 1383.91H100.381L98.3974 1390.43H96.7014L94.5654 1382.51V1382.27ZM107.254 1386.35C107.254 1383.58 108.79 1382.08 111.206 1382.08C113.63 1382.08 114.966 1383.59 114.966 1385.99V1386.7H108.614C108.646 1388.39 109.622 1389.48 111.206 1389.48C112.71 1389.48 113.406 1388.63 113.534 1387.87H114.798V1388.11C114.614 1389.11 113.67 1390.62 111.222 1390.62C108.806 1390.62 107.254 1389.12 107.254 1386.35ZM108.638 1385.59H113.622C113.606 1384.19 112.782 1383.21 111.198 1383.21C109.646 1383.21 108.75 1384.21 108.638 1385.59ZM116.804 1382.27H118.164V1383.25H118.292C118.572 1382.67 119.084 1382.24 120.308 1382.24H121.444V1383.46H120.34C118.812 1383.46 118.212 1384.3 118.212 1385.95V1390.43H116.804V1382.27Z" fill={textFillColor} />;
    $[24] = textFillColor;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== pathsFillColor) {
    t15 = <path d="M276.972 1385.43L133.972 1385.42" stroke={pathsFillColor} strokeWidth={_styles.labels.dashWidth} strokeLinecap="round" />;
    $[26] = pathsFillColor;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
    t16 = <g opacity={t13} style={_styles.transitions} transform="translate(0 -50)">{t14}{t15}</g>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const t17 = selectedPart === 0 ? _styles.opacities.full : _styles.opacities.hidden;
  let t18;
  if ($[32] !== pathsFillColor || $[33] !== t17) {
    t18 = <path id="first-path" d="M268.468 109.474v295" stroke={pathsFillColor} strokeWidth="1.75" strokeLinecap="round" strokeDasharray="0.1 4" opacity={t17} style={_styles.transitions} />;
    $[32] = pathsFillColor;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  const t19 = selectedPart === 0 ? 1 : 0;
  let t20;
  if ($[35] !== pathsFillColor) {
    t20 = <path d="M6.2683 0l-6.2683 6l-6.2683 -6" stroke={pathsFillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90)" />;
    $[35] = pathsFillColor;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <animateMotion dur="4s" begin="0s" rotate="auto" repeatCount="indefinite"><mpath href="#first-path" /></animateMotion>;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t20) {
    t22 = <g>{t20}{t21}</g>;
    $[38] = t20;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <animate attributeName="opacity" from="0" to="1" begin="2s" dur="0.01s" fill="freeze" />;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== pathsFillColor) {
    t24 = <path d="M6.2683 0l-6.2683 6l-6.2683 -6" stroke={pathsFillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90)" opacity="0">{t23}</path>;
    $[41] = pathsFillColor;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <animateMotion dur="4s" begin="2s" rotate="auto" repeatCount="indefinite"><mpath href="#first-path" /></animateMotion>;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t24) {
    t26 = <g>{t24}{t25}</g>;
    $[44] = t24;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t19 || $[47] !== t22 || $[48] !== t26) {
    t27 = <g opacity={t19} style={_styles.transitions}>{t22}{t26}</g>;
    $[46] = t19;
    $[47] = t22;
    $[48] = t26;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  const t28 = selectedPart === 1 ? _styles.opacities.full : _styles.opacities.hidden;
  let t29;
  let t30;
  let t31;
  if ($[50] !== pathsFillColor) {
    t29 = <path id="second-path-long-vertical" d="M268.46 558.8L268.46 760" stroke={pathsFillColor} strokeWidth="1.75" strokeLinecap="round" strokeDasharray="0.1 4" />;
    t30 = <path id="second-path-left-part" d="M268.448 680.458L97.1001 680.458C86.0544 680.458 77.1001 689.413 77.1001 700.458L77.1001 825" stroke={pathsFillColor} strokeWidth="1.75" strokeLinecap="round" strokeDasharray="0.1 4" />;
    t31 = <path id="second-path-right-part" d="M268.448 680.458L439.535 680.458C450.563 680.458 459.51 689.386 459.535 700.414L459.809 825" stroke={pathsFillColor} strokeWidth="1.75" strokeLinecap="round" strokeDasharray="0.1 4" />;
    $[50] = pathsFillColor;
    $[51] = t29;
    $[52] = t30;
    $[53] = t31;
  } else {
    t29 = $[51];
    t30 = $[52];
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t28 || $[55] !== t29 || $[56] !== t30 || $[57] !== t31) {
    t32 = <g opacity={t28} style={_styles.transitions}>{t29}{t30}{t31}</g>;
    $[54] = t28;
    $[55] = t29;
    $[56] = t30;
    $[57] = t31;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  const t33 = selectedPart === 1 ? 1 : 0;
  let t34;
  if ($[59] !== pathsFillColor) {
    t34 = <path d="M6.2683 0l-6.2683 6l-6.2683 -6" stroke={pathsFillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90)" />;
    $[59] = pathsFillColor;
    $[60] = t34;
  } else {
    t34 = $[60];
  }
  let t35;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <animateMotion dur="2s" begin="0s" rotate="auto" repeatCount="indefinite"><mpath href="#second-path-long-vertical" /></animateMotion>;
    $[61] = t35;
  } else {
    t35 = $[61];
  }
  let t36;
  if ($[62] !== t34) {
    t36 = <g>{t34}{t35}</g>;
    $[62] = t34;
    $[63] = t36;
  } else {
    t36 = $[63];
  }
  let t37;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <animate attributeName="opacity" from="0" to="1" begin="1.26s" dur="0.01s" fill="freeze" />;
    $[64] = t37;
  } else {
    t37 = $[64];
  }
  let t38;
  if ($[65] !== pathsFillColor) {
    t38 = <path d="M6.2683 0l-6.2683 6l-6.2683 -6" stroke={pathsFillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90)" opacity="0">{t37}</path>;
    $[65] = pathsFillColor;
    $[66] = t38;
  } else {
    t38 = $[66];
  }
  let t39;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <animateMotion dur="2s" begin="1.26s" rotate="auto" repeatCount="indefinite"><mpath href="#second-path-right-part" /></animateMotion>;
    $[67] = t39;
  } else {
    t39 = $[67];
  }
  let t40;
  if ($[68] !== t38) {
    t40 = <g>{t38}{t39}</g>;
    $[68] = t38;
    $[69] = t40;
  } else {
    t40 = $[69];
  }
  let t41;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <animate attributeName="opacity" from="0" to="1" begin="1.26s" dur="0.01s" fill="freeze" />;
    $[70] = t41;
  } else {
    t41 = $[70];
  }
  let t42;
  if ($[71] !== pathsFillColor) {
    t42 = <path d="M6.2683 0l-6.2683 6l-6.2683 -6" stroke={pathsFillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90)" opacity="0">{t41}</path>;
    $[71] = pathsFillColor;
    $[72] = t42;
  } else {
    t42 = $[72];
  }
  let t43;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <animateMotion dur="2s" begin="1.26s" rotate="auto" repeatCount="indefinite"><mpath href="#second-path-left-part" /></animateMotion>;
    $[73] = t43;
  } else {
    t43 = $[73];
  }
  let t44;
  if ($[74] !== t42) {
    t44 = <g>{t42}{t43}</g>;
    $[74] = t42;
    $[75] = t44;
  } else {
    t44 = $[75];
  }
  let t45;
  if ($[76] !== t33 || $[77] !== t36 || $[78] !== t40 || $[79] !== t44) {
    t45 = <g opacity={t33} style={_styles.transitions}>{t36}{t40}{t44}</g>;
    $[76] = t33;
    $[77] = t36;
    $[78] = t40;
    $[79] = t44;
    $[80] = t45;
  } else {
    t45 = $[80];
  }
  const t46 = selectedPart === 2 ? _styles.opacities.full : _styles.opacities.hidden;
  let t47;
  let t48;
  let t49;
  if ($[81] !== pathsFillColor) {
    t47 = <path id="third-path-vertical-part" d="M268.468 1387.43L268.468 930" stroke={pathsFillColor} strokeWidth="1.75" strokeLinecap="round" strokeDasharray="0.1 4" />;
    t48 = <path id="third-path-left-part" d="M268.512 1009.24L97.1016 1009.24C86.0559 1009.24 77.1016 1000.28 77.1016 989.237L77.1016 930" stroke={pathsFillColor} strokeWidth="1.75" strokeLinecap="round" strokeDasharray="0.1 4" />;
    t49 = <path id="third-path-right-part" d="M268.472 1009.24L439.826 1009.24C450.872 1009.24 459.826 1000.28 459.826 989.237L459.826 930" stroke={pathsFillColor} strokeWidth="1.75" strokeLinecap="round" strokeDasharray="0.1 4" />;
    $[81] = pathsFillColor;
    $[82] = t47;
    $[83] = t48;
    $[84] = t49;
  } else {
    t47 = $[82];
    t48 = $[83];
    t49 = $[84];
  }
  let t50;
  if ($[85] !== t46 || $[86] !== t47 || $[87] !== t48 || $[88] !== t49) {
    t50 = <g opacity={t46} style={_styles.transitions}>{t47}{t48}{t49}</g>;
    $[85] = t46;
    $[86] = t47;
    $[87] = t48;
    $[88] = t49;
    $[89] = t50;
  } else {
    t50 = $[89];
  }
  const t51 = selectedPart === 2 ? 1 : 0;
  let t52;
  if ($[90] !== pathsFillColor) {
    t52 = <path d="M6.2683 0l-6.2683 6l-6.2683 -6" stroke={pathsFillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90)" />;
    $[90] = pathsFillColor;
    $[91] = t52;
  } else {
    t52 = $[91];
  }
  let t53;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <animateMotion dur="3s" begin="0s" rotate="auto" repeatCount="indefinite"><mpath href="#third-path-vertical-part" /></animateMotion>;
    $[92] = t53;
  } else {
    t53 = $[92];
  }
  let t54;
  if ($[93] !== t52) {
    t54 = <g>{t52}{t53}</g>;
    $[93] = t52;
    $[94] = t54;
  } else {
    t54 = $[94];
  }
  let t55;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <animate attributeName="opacity" from="0" to="1" begin="2s" dur="0.01s" fill="freeze" />;
    $[95] = t55;
  } else {
    t55 = $[95];
  }
  let t56;
  if ($[96] !== pathsFillColor) {
    t56 = <path d="M6.2683 0l-6.2683 6l-6.2683 -6" stroke={pathsFillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90)" opacity="0">{t55}</path>;
    $[96] = pathsFillColor;
    $[97] = t56;
  } else {
    t56 = $[97];
  }
  let t57;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <animateMotion dur="3s" begin="2.4375s" rotate="auto" repeatCount="indefinite"><mpath href="#third-path-left-part" /></animateMotion>;
    $[98] = t57;
  } else {
    t57 = $[98];
  }
  let t58;
  if ($[99] !== t56) {
    t58 = <g>{t56}{t57}</g>;
    $[99] = t56;
    $[100] = t58;
  } else {
    t58 = $[100];
  }
  let t59;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = <animate attributeName="opacity" from="0" to="1" begin="2s" dur="0.01s" fill="freeze" />;
    $[101] = t59;
  } else {
    t59 = $[101];
  }
  let t60;
  if ($[102] !== pathsFillColor) {
    t60 = <path d="M6.2683 0l-6.2683 6l-6.2683 -6" stroke={pathsFillColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" transform="rotate(-90)" opacity="0">{t59}</path>;
    $[102] = pathsFillColor;
    $[103] = t60;
  } else {
    t60 = $[103];
  }
  let t61;
  if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <animateMotion dur="3s" begin="2.4375s" rotate="auto" repeatCount="indefinite"><mpath href="#third-path-right-part" /></animateMotion>;
    $[104] = t61;
  } else {
    t61 = $[104];
  }
  let t62;
  if ($[105] !== t60) {
    t62 = <g>{t60}{t61}</g>;
    $[105] = t60;
    $[106] = t62;
  } else {
    t62 = $[106];
  }
  let t63;
  if ($[107] !== t51 || $[108] !== t54 || $[109] !== t58 || $[110] !== t62) {
    t63 = <g opacity={t51} style={_styles.transitions}>{t54}{t58}{t62}</g>;
    $[107] = t51;
    $[108] = t54;
    $[109] = t58;
    $[110] = t62;
    $[111] = t63;
  } else {
    t63 = $[111];
  }
  let t64;
  let t65;
  let t66;
  let t67;
  let t68;
  let t69;
  let t70;
  let t71;
  if ($[112] !== backgroundFillColor) {
    t64 = <circle fill={backgroundFillColor} r="50" transform="translate(270 86) scale(0.4, 1)" />;
    t65 = <circle fill={backgroundFillColor} r="47" transform="translate(270 236) scale(0.5, 1)" />;
    t66 = <ellipse fill={backgroundFillColor} rx="50" ry="105" transform="translate(270 452)" />;
    t67 = <circle fill={backgroundFillColor} r="57" transform="translate(268 820)" />;
    t68 = <circle fill={backgroundFillColor} r="57" transform="translate(76 820)" />;
    t69 = <circle fill={backgroundFillColor} r="57" transform="translate(460 820)" />;
    t70 = <circle fill={backgroundFillColor} r="46" transform="translate(268 1138)" />;
    t71 = <circle fill={backgroundFillColor} r="40" transform="translate(268 1303)" />;
    $[112] = backgroundFillColor;
    $[113] = t64;
    $[114] = t65;
    $[115] = t66;
    $[116] = t67;
    $[117] = t68;
    $[118] = t69;
    $[119] = t70;
    $[120] = t71;
  } else {
    t64 = $[113];
    t65 = $[114];
    t66 = $[115];
    t67 = $[116];
    t68 = $[117];
    t69 = $[118];
    t70 = $[119];
    t71 = $[120];
  }
  const t72 = selectedPart === 0 ? _styles.opacities.full : _styles.opacities.hidden;
  const t73 = `${base}/person.png`;
  let t74;
  if ($[121] !== t73) {
    t74 = <image href={t73} x="222" y="0" height="136" />;
    $[121] = t73;
    $[122] = t74;
  } else {
    t74 = $[122];
  }
  const t75 = `${base}/weth.png`;
  let t76;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t76 = {
      filter: "brightness(118%)"
    };
    $[123] = t76;
  } else {
    t76 = $[123];
  }
  let t77;
  if ($[124] !== t75) {
    t77 = <image href={t75} x="232" y="187" height="97" style={t76} />;
    $[124] = t75;
    $[125] = t77;
  } else {
    t77 = $[125];
  }
  let t78;
  if ($[126] !== t72 || $[127] !== t74 || $[128] !== t77) {
    t78 = <g opacity={t72} style={_styles.transitions}>{t74}{t77}</g>;
    $[126] = t72;
    $[127] = t74;
    $[128] = t77;
    $[129] = t78;
  } else {
    t78 = $[129];
  }
  const t79 = `${base}/weth-vault.png`;
  const t80 = selectedPart === 0 || selectedPart === 1 ? _styles.opacities.full : _styles.opacities.hidden;
  let t81;
  if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = {
      ..._styles.transitions,
      transform: "scale(-1, 1)",
      transformOrigin: "center center"
    };
    $[130] = t81;
  } else {
    t81 = $[130];
  }
  let t82;
  if ($[131] !== t79 || $[132] !== t80) {
    t82 = <image href={t79} x="174" y="343" height="218" opacity={t80} style={t81} />;
    $[131] = t79;
    $[132] = t80;
    $[133] = t82;
  } else {
    t82 = $[133];
  }
  const t83 = selectedPart === 2 ? _styles.opacities.full : _styles.opacities.hidden;
  const t84 = `${base}/yield.png`;
  let t85;
  if ($[134] === Symbol.for("react.memo_cache_sentinel")) {
    t85 = {
      filter: "brightness(130%) contrast(0.9)"
    };
    $[134] = t85;
  } else {
    t85 = $[134];
  }
  let t86;
  if ($[135] !== t84) {
    t86 = <image href={t84} x="232" y="1090" height="98" style={t85} />;
    $[135] = t84;
    $[136] = t86;
  } else {
    t86 = $[136];
  }
  const t87 = `${base}/person.png`;
  let t88;
  if ($[137] !== t87) {
    t88 = <image href={t87} x="222" y="1260" height="136" />;
    $[137] = t87;
    $[138] = t88;
  } else {
    t88 = $[138];
  }
  let t89;
  if ($[139] !== t83 || $[140] !== t86 || $[141] !== t88) {
    t89 = <g opacity={t83} style={_styles.transitions}>{t86}{t88}</g>;
    $[139] = t83;
    $[140] = t86;
    $[141] = t88;
    $[142] = t89;
  } else {
    t89 = $[142];
  }
  const t90 = selectedPart === 1 || selectedPart === 2 ? _styles.opacities.full : _styles.opacities.hidden;
  const t91 = `${base}/coinstack.png`;
  let t92;
  if ($[143] !== t91) {
    t92 = <image href={t91} x="4" y="741" width="140" height="160" />;
    $[143] = t91;
    $[144] = t92;
  } else {
    t92 = $[144];
  }
  const t93 = `${base}/coinstack.png`;
  let t94;
  if ($[145] !== t93) {
    t94 = <image href={t93} x="197" y="741" width="140" height="160" />;
    $[145] = t93;
    $[146] = t94;
  } else {
    t94 = $[146];
  }
  const t95 = `${base}/coinstack.png`;
  let t96;
  if ($[147] !== t95) {
    t96 = <image href={t95} x="390" y="741" width="140" height="160" />;
    $[147] = t95;
    $[148] = t96;
  } else {
    t96 = $[148];
  }
  let t97;
  let t98;
  let t99;
  if ($[149] !== textFillColor) {
    t97 = <path d="M23.043 903.767H24.219L25.668 909.493H25.787L27.523 903.767H28.888L30.631 909.493H30.743L32.185 903.767H33.326V903.977L31.457 910.9H29.98L28.244 905.195H28.132L26.396 910.9H24.912L23.043 903.977V903.767ZM34.2771 905.636C34.2771 904.369 35.3551 903.606 37.1821 903.606C39.0161 903.606 40.1361 904.369 40.2481 905.727V905.937H39.1211C39.0721 904.95 38.3021 904.579 37.1891 904.579C36.0761 904.579 35.4531 904.943 35.4531 905.608C35.4531 906.273 35.9851 906.532 36.7411 906.623L37.9661 906.777C39.3871 906.952 40.3671 907.561 40.3671 908.863C40.3671 910.179 39.3451 911.061 37.3851 911.061C35.4251 911.061 34.2001 910.186 34.1161 908.891V908.681H35.2571C35.3271 909.647 36.1951 910.088 37.3851 910.088C38.5821 910.088 39.1771 909.64 39.1771 908.926C39.1771 908.226 38.6171 907.918 37.7001 907.799L36.4751 907.645C35.1521 907.477 34.2771 906.889 34.2771 905.636ZM41.0756 903.767H42.7626V901.807H43.9946V903.767H46.1296V904.768H43.9946V909.724L44.1066 909.836H46.1086V910.9H44.5966C43.4276 910.9 42.7626 910.319 42.7626 909.157V904.768H41.0756V903.767ZM47.7411 900.82H54.7551V901.905H49.0151V905.265H54.0551V906.35H49.0151V909.815H54.8531V910.9H47.7411V900.82ZM55.7551 900.82H64.3231V901.933H60.6831V910.9H59.3951V901.933H55.7551V900.82ZM65.829 900.82H67.11V905.272H72.514V900.82H73.802V910.9H72.514V906.406H67.11V910.9H65.829V900.82ZM82.6158 900.82H83.8058V901.03L79.8578 910.9H78.6678V910.69L82.6158 900.82ZM87.8373 900.82H89.0973L91.1273 909.493H91.2393L93.5703 900.82H95.0963L97.4203 909.493H97.5323L99.5623 900.82H100.787V901.03L98.3863 910.9H96.6503L94.3683 902.423H94.2563L91.9743 910.9H90.2383L87.8373 901.03V900.82ZM102.347 900.82H109.361V901.905H103.621V905.265H108.661V906.35H103.621V909.815H109.459V910.9H102.347V900.82ZM110.361 900.82H118.929V901.933H115.289V910.9H114.001V901.933H110.361V900.82ZM120.434 900.82H121.715V905.272H127.119V900.82H128.407V910.9H127.119V906.406H121.715V910.9H120.434V900.82Z" fill={textFillColor} />;
    t98 = <path d="M226.552 905.636C226.552 904.369 227.63 903.606 229.457 903.606C231.291 903.606 232.411 904.369 232.523 905.727V905.937H231.396C231.347 904.95 230.577 904.579 229.464 904.579C228.351 904.579 227.728 904.943 227.728 905.608C227.728 906.273 228.26 906.532 229.016 906.623L230.241 906.777C231.662 906.952 232.642 907.561 232.642 908.863C232.642 910.179 231.62 911.061 229.66 911.061C227.7 911.061 226.475 910.186 226.391 908.891V908.681H227.532C227.602 909.647 228.47 910.088 229.66 910.088C230.857 910.088 231.452 909.64 231.452 908.926C231.452 908.226 230.892 907.918 229.975 907.799L228.75 907.645C227.427 907.477 226.552 906.889 226.552 905.636ZM237.97 900.82C240.938 900.82 242.912 902.724 242.912 905.86C242.912 908.996 240.938 910.9 237.97 910.9H234.274V900.82H237.97ZM235.555 909.794H237.935C240.133 909.794 241.61 908.401 241.61 905.86C241.61 903.319 240.133 901.926 237.935 901.926H235.555V909.794ZM247.173 900.82H248.825L252.507 910.69V910.9H251.226L250.162 908.002H245.801L244.744 910.9H243.498V910.69L247.173 900.82ZM246.172 906.896H249.791L248.041 902.108H247.929L246.172 906.896ZM254.03 900.82H255.318V910.9H254.03V900.82ZM264.131 900.82H265.321V901.03L261.373 910.9H260.183V910.69L264.131 900.82ZM269.352 900.82H270.612L272.642 909.493H272.754L275.085 900.82H276.611L278.935 909.493H279.047L281.077 900.82H282.302V901.03L279.901 910.9H278.165L275.883 902.423H275.771L273.489 910.9H271.753L269.352 901.03V900.82ZM283.862 900.82H290.876V901.905H285.136V905.265H290.176V906.35H285.136V909.815H290.974V910.9H283.862V900.82ZM291.876 900.82H300.444V901.933H296.804V910.9H295.516V901.933H291.876V900.82ZM301.95 900.82H303.231V905.272H308.635V900.82H309.923V910.9H308.635V906.406H303.231V910.9H301.95V900.82Z" fill={textFillColor} />;
    t99 = <path d="M406.918 905.636C406.918 904.369 407.996 903.606 409.823 903.606C411.657 903.606 412.777 904.369 412.889 905.727V905.937H411.762C411.713 904.95 410.943 904.579 409.83 904.579C408.717 904.579 408.094 904.943 408.094 905.608C408.094 906.273 408.626 906.532 409.382 906.623L410.607 906.777C412.028 906.952 413.008 907.561 413.008 908.863C413.008 910.179 411.986 911.061 410.026 911.061C408.066 911.061 406.841 910.186 406.757 908.891V908.681H407.898C407.968 909.647 408.836 910.088 410.026 910.088C411.223 910.088 411.818 909.64 411.818 908.926C411.818 908.226 411.258 907.918 410.341 907.799L409.116 907.645C407.793 907.477 406.918 906.889 406.918 905.636ZM413.73 904.768V903.767H415.473V902.563C415.473 901.401 416.138 900.82 417.307 900.82H418.91V901.821H416.817L416.705 901.933V903.767H418.756V904.768H416.705V910.9H415.473V904.768H413.73ZM420.024 903.767H421.214V904.621H421.326C421.571 904.117 422.019 903.739 423.09 903.739H424.084V904.803H423.118C421.781 904.803 421.256 905.538 421.256 906.987V910.9H420.024V903.767ZM425.089 903.767H426.356L428.358 906.42H428.47L430.633 903.767H431.872V903.977L429.17 907.288L431.753 910.69V910.9H430.493L428.4 908.135H428.288L426.034 910.9H424.795V910.69L427.588 907.274L425.089 903.977V903.767ZM433.507 900.82H440.521V901.905H434.781V905.265H439.821V906.35H434.781V909.815H440.619V910.9H433.507V900.82ZM441.521 900.82H450.089V901.933H446.449V910.9H445.161V901.933H441.521V900.82ZM451.595 900.82H452.876V905.272H458.28V900.82H459.568V910.9H458.28V906.406H452.876V910.9H451.595V900.82ZM468.382 900.82H469.572V901.03L465.624 910.9H464.434V910.69L468.382 900.82ZM473.603 900.82H474.863L476.893 909.493H477.005L479.336 900.82H480.862L483.186 909.493H483.298L485.328 900.82H486.553V901.03L484.152 910.9H482.416L480.134 902.423H480.022L477.74 910.9H476.004L473.603 901.03V900.82ZM488.113 900.82H495.127V901.905H489.387V905.265H494.427V906.35H489.387V909.815H495.225V910.9H488.113V900.82ZM496.127 900.82H504.695V901.933H501.055V910.9H499.767V901.933H496.127V900.82ZM506.201 900.82H507.482V905.272H512.886V900.82H514.174V910.9H512.886V906.406H507.482V910.9H506.201V900.82Z" fill={textFillColor} />;
    $[149] = textFillColor;
    $[150] = t97;
    $[151] = t98;
    $[152] = t99;
  } else {
    t97 = $[150];
    t98 = $[151];
    t99 = $[152];
  }
  let t100;
  if ($[153] !== t90 || $[154] !== t92 || $[155] !== t94 || $[156] !== t96 || $[157] !== t97 || $[158] !== t98 || $[159] !== t99) {
    t100 = <g opacity={t90} style={_styles.transitions}>{t92}{t94}{t96}{t97}{t98}{t99}</g>;
    $[153] = t90;
    $[154] = t92;
    $[155] = t94;
    $[156] = t96;
    $[157] = t97;
    $[158] = t98;
    $[159] = t99;
    $[160] = t100;
  } else {
    t100 = $[160];
  }
  let t101;
  if ($[161] !== className || $[162] !== ref || $[163] !== style || $[164] !== t100 || $[165] !== t12 || $[166] !== t16 || $[167] !== t18 || $[168] !== t27 || $[169] !== t32 || $[170] !== t4 || $[171] !== t45 || $[172] !== t50 || $[173] !== t63 || $[174] !== t64 || $[175] !== t65 || $[176] !== t66 || $[177] !== t67 || $[178] !== t68 || $[179] !== t69 || $[180] !== t70 || $[181] !== t71 || $[182] !== t78 || $[183] !== t8 || $[184] !== t82 || $[185] !== t89) {
    t101 = <svg viewBox="0 0 537 1415" fill="none" className={className} ref={ref} style={style}>{t4}{t8}{t12}{t16}{t18}{t27}{t32}{t45}{t50}{t63}{t64}{t65}{t66}{t67}{t68}{t69}{t70}{t71}{t78}{t82}{t89}{t100}</svg>;
    $[161] = className;
    $[162] = ref;
    $[163] = style;
    $[164] = t100;
    $[165] = t12;
    $[166] = t16;
    $[167] = t18;
    $[168] = t27;
    $[169] = t32;
    $[170] = t4;
    $[171] = t45;
    $[172] = t50;
    $[173] = t63;
    $[174] = t64;
    $[175] = t65;
    $[176] = t66;
    $[177] = t67;
    $[178] = t68;
    $[179] = t69;
    $[180] = t70;
    $[181] = t71;
    $[182] = t78;
    $[183] = t8;
    $[184] = t82;
    $[185] = t89;
    $[186] = t101;
  } else {
    t101 = $[186];
  }
  return t101;
}
export default memo(forwardRef(HowItWorksEarnGraphics));